export enum SurveyRoutePathList {
	module1 = '/module/1',
	module2 = '/module/2',
	module3 = '/module/3',
	finish = '/finish',
}
